(window as any).__AMAZEMOVE_CONFIG = {
  env: process.env.AMAZEMOVE_ENV,
  apiLocation: process.env.API_LOCATION,
};
export const IS_DEV = !process.env.AMAZEMOVE_ENV || process.env.AMAZEMOVE_ENV === "development";
export const IS_TEST = process.env.AMAZEMOVE_ENV === "test";
export const IS_PRE = process.env.AMAZEMOVE_ENV === "pre";
export const IS_PROD = process.env.AMAZEMOVE_ENV === "production";

/** 客服系统ws路径 */
const getWsPath = () => {
  let prefix,
    domain = "amazwear.com";
  if (IS_DEV) {
    prefix = "devwebsocket";
  } else if (IS_TEST) {
    prefix = "testwebsocket";
  } else if (IS_PRE) {
    prefix = "prewebsocket";
  } else {
    prefix = "websocket";
  }
  switch (process.env.API_LOCATION) {
    case "hk":
      prefix = "websocket-hk";
      break;
    case "cn":
      domain = "apexmove.com";
      if (IS_DEV) {
        prefix = "websocket-dev";
      } else if (IS_TEST) {
        prefix = "websocket-test";
      } else if (IS_PRE) {
        prefix = "websocket-pre";
      }
      break;
    default:
      break;
  }
  return `wss://${prefix}.${domain}/websocket/user`;
};
export const WS_PATH = getWsPath();
// export const WS_PATH = `ws://192.168.110.217:8207/websocket/user`;
export const FILE_UPLOAD_CODE = IS_DEV || IS_TEST || process.env.API_LOCATION ? "aliyun" : "amazon";

export const GLOBAL_KEYS = {
  USER_INFO: "_uis",
  USER_TOKEN: "token",
  TOKEN_EXPIRE: "_te",
  PLAT_THEME: "_pt",
  API_LOCATION: "_al",
};

const getCompanySettings = () => {
  switch (process.env.API_LOCATION) {
    case "cn":
      return {
        title: "猎动",
        slogan: "您的的健康与健身伴侣",
        copyright: "Copyright © 2025 Hongkong Amazwear Tech CO., LTD. ",
      };
    default:
      return {
        title: "APEXMOVE",
        slogan: "WATCH YOU WANT!",
        copyright: "Copyright © 2025 Hongkong Amazwear Tech CO., LTD. ",
      };
  }
};

export const COMPANY_SETTINGS = getCompanySettings();
